import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown } from "lucide-react";

export function TrialLimitModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user, isPremium } = useAuth();
  // Jika user masih eligible Paket Coba 3 Hari, ThreeDayOfferModal yang menangani event ini
  const offerEligible = !!user && !isPremium() && user.intro_pass_used !== true;
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("trial-exhausted", h);
    return () => window.removeEventListener("trial-exhausted", h);
  }, []);
  return (
    <Dialog open={open && !offerEligible} onOpenChange={setOpen}>
      <DialogContent className="bg-white max-w-md" data-testid="trial-limit-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Crown className="w-5 h-5 text-amber-500" />Analisis gratis Anda sudah habis</DialogTitle>
          <DialogDescription className="sr-only">Penawaran paket berbayar untuk melanjutkan analisis.</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">Lanjutkan analisis tanpa batas mulai <b>Rp15.000</b>. Bandingkan kandidat, hitung biaya kepemilikan, cek kecocokan rute, dan simpan hasil Anda.</p>
        <div className="flex flex-col gap-2 mt-2">
          <Button data-testid="trial-limit-continue" onClick={() => { setOpen(false); navigate("/premium"); }} className="rounded-full bg-teal hover:bg-teal-hover h-11">Lanjutkan Analisis Saya</Button>
          <button data-testid="trial-limit-plans" onClick={() => { setOpen(false); navigate("/premium"); }} className="text-sm text-muted-foreground hover:text-navy">Lihat Paket</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
